import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const opcoesTipo = [
  { value: 'otimo', label: 'Ótimo' },
  { value: 'bom', label: 'Bom' },
  { value: 'regular', label: 'Regular' },
  { value: 'ruim', label: 'Ruim' }
];

const opcoesRecomendacao = [
  { value: 'sim_certeza', label: 'Sim, com certeza' },
  { value: 'provavelmente_sim', label: 'Provavelmente sim' },
  { value: 'talvez', label: 'Talvez' },
  { value: 'provavelmente_nao', label: 'Provavelmente não' },
  { value: 'nao', label: 'Não' }
];

function RatingRow({ criterio, name, value, onChange }) {
  return (
    <tr>
      <td>{criterio}</td>
      {opcoesTipo.map(opcao => (
        <td key={opcao.value}>
          <div className="radio-group">
            <label className={`radio-btn rating-${opcao.value}`}>
              <input
                type="radio"
                name={name}
                value={opcao.value}
                checked={value === opcao.value}
                onChange={(e) => onChange(name, e.target.value)}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </td>
      ))}
    </tr>
  );
}

function AvaliacaoForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [anonimo, setAnonimo] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: '',
    data_internacao: '',
    quarto_leito: '',
    setor: '',
    recepcao_cordialidade: '',
    recepcao_agilidade: '',
    recepcao_clareza: '',
    recepcao_outro: '',
    enfermagem_cordialidade: '',
    enfermagem_rapidez: '',
    enfermagem_cuidado_medicamentos: '',
    enfermagem_orientacoes: '',
    enfermagem_atencao: '',
    enfermagem_outro: '',
    estrutura_limpeza_quarto: '',
    estrutura_limpeza_banheiro: '',
    estrutura_conforto_cama: '',
    estrutura_temperatura: '',
    estrutura_ruido: '',
    estrutura_equipamentos: '',
    estrutura_outro: '',
    alimentacao_qualidade: '',
    alimentacao_temperatura: '',
    alimentacao_variedade: '',
    alimentacao_apresentacao: '',
    alimentacao_pontualidade: '',
    alimentacao_atendimento_copeira: '',
    alimentacao_outro: '',
    nota_geral: null,
    recomendaria: '',
    avaliacao_geral_outro: '',
    profissional_destaque: '',
    sugestao_melhoria: '',
    elogio_reclamacao: ''
  });

  const handleChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const formatWhatsApp = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 7) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handleWhatsAppChange = (e) => {
    const formatted = formatWhatsApp(e.target.value);
    setFormData(prev => ({ ...prev, whatsapp: formatted }));
  };

  const validateStep = () => {
    if (step === 1 && !anonimo) {
      if (!formData.nome || !formData.email || !formData.whatsapp) {
        alert('Por favor, preencha todos os campos obrigatórios.');
        return false;
      }
      if (!formData.email.includes('@')) {
        alert('Por favor, insira um email válido.');
        return false;
      }
      if (formData.whatsapp.replace(/\D/g, '').length < 10) {
        alert('Por favor, insira um WhatsApp válido.');
        return false;
      }
    }
    return true;
  };

  const nextStep = () => {
    if (validateStep()) {
      setStep(prev => prev + 1);
      window.scrollTo(0, 0);
    }
  };

  const prevStep = () => {
    setStep(prev => prev - 1);
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const dadosEnvio = { ...formData, anonimo };
      if (anonimo) {
        dadosEnvio.nome = 'Anônimo';
        dadosEnvio.email = '';
        dadosEnvio.whatsapp = '';
      }
      const response = await axios.post(`${API_URL}/avaliacao`, dadosEnvio);
      navigate('/sucesso', {
        state: {
          positiva: response.data.positiva,
          googleReviewLink: response.data.googleReviewLink,
          nome: anonimo ? 'Paciente' : formData.nome
        }
      });
    } catch (error) {
      console.error('Erro ao enviar avaliação:', error);
      alert('Ocorreu um erro ao enviar sua avaliação. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const totalSteps = anonimo ? 6 : 7;
  const currentStep = anonimo ? step - 1 : step;
  const progress = step === 0 ? 0 : (currentStep / totalSteps) * 100;

  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="header-top">
          <a href="https://hospitalunique.com.br" target="_blank" rel="noopener noreferrer">Visite nosso site</a>
        </div>
        <div className="header-main">
          <img src="/logo.jpg" alt="Hospital Unique" className="header-logo" />
          <div className="header-title">
            <h1>Pesquisa de Satisfação</h1>
            <p>Sua opinião é muito importante para nós</p>
          </div>
        </div>
      </header>

      {/* Intro */}
      {step === 0 && (
        <div className="intro-section">
          <h2>Excelência em saúde,<br />com o aconchego que você merece</h2>
          <p>Dedique alguns minutos para nos contar sobre sua experiência. Suas respostas são confidenciais e nos ajudam a melhorar continuamente.</p>
          <button className="btn btn-primary btn-lg" style={{ marginTop: '30px' }} onClick={nextStep}>
            Iniciar Avaliação
          </button>
          <button
            className="btn btn-secondary btn-lg"
            style={{ marginTop: '15px', display: 'block', marginLeft: 'auto', marginRight: 'auto', opacity: 0.85 }}
            onClick={() => { setAnonimo(true); setStep(2); window.scrollTo(0, 0); }}
          >
            Avaliação Anônima
          </button>
        </div>
      )}

      {step > 0 && (
        <div className="container">
          {/* Progress */}
          <div className="progress-container">
            <div className="progress-info">
              <span>Etapa {currentStep} de {totalSteps}</span>
              <span>{Math.round(progress)}% concluído</span>
            </div>
            <div className="progress-bar">
              <div className="fill" style={{ width: `${progress}%` }}></div>
            </div>
          </div>

          {/* Step 1: Dados Pessoais */}
          {step === 1 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">👤</span>
                <h2>Seus Dados</h2>
              </div>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '25px' }}>
                Precisamos de algumas informações para contato.
              </p>
              <div className="form-group">
                <label>Nome Completo *</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  placeholder="Digite seu nome completo"
                />
              </div>
              <div className="form-group">
                <label>E-mail *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="seu@email.com"
                />
              </div>
              <div className="form-group">
                <label>WhatsApp *</label>
                <input
                  type="tel"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleWhatsAppChange}
                  placeholder="(62) 99999-9999"
                />
              </div>

              <div className="card-header" style={{ marginTop: '35px' }}>
                <span className="icon">📋</span>
                <h2>Dados da Internação</h2>
              </div>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '20px', fontSize: '0.9rem' }}>
                Opcional - preencha se desejar
              </p>
              <div className="form-row">
                <div className="form-group">
                  <label>Data da Internação</label>
                  <input
                    type="date"
                    name="data_internacao"
                    value={formData.data_internacao}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Quarto/Leito</label>
                  <input
                    type="text"
                    name="quarto_leito"
                    value={formData.quarto_leito}
                    onChange={handleInputChange}
                    placeholder="Ex: 101-A"
                  />
                </div>
                <div className="form-group">
                  <label>Setor</label>
                  <input
                    type="text"
                    name="setor"
                    value={formData.setor}
                    onChange={handleInputChange}
                    placeholder="Ex: Cirúrgico"
                  />
                </div>
              </div>
              <button className="btn btn-primary btn-block" onClick={nextStep}>
                Continuar
              </button>
            </div>
          )}

          {/* Step 2: Recepção e Admissão */}
          {step === 2 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">🛎️</span>
                <h2>Recepção e Admissão</h2>
              </div>
              <table className="rating-table">
                <thead>
                  <tr>
                    <th>Critério</th>
                    <th>Ótimo</th>
                    <th>Bom</th>
                    <th>Regular</th>
                    <th>Ruim</th>
                  </tr>
                </thead>
                <tbody>
                  <RatingRow criterio="Cordialidade no atendimento" name="recepcao_cordialidade" value={formData.recepcao_cordialidade} onChange={handleChange} />
                  <RatingRow criterio="Agilidade no processo de internação" name="recepcao_agilidade" value={formData.recepcao_agilidade} onChange={handleChange} />
                  <RatingRow criterio="Clareza nas informações" name="recepcao_clareza" value={formData.recepcao_clareza} onChange={handleChange} />
                </tbody>
              </table>
              <div className="form-group" style={{ marginTop: '25px' }}>
                <label>Observações (opcional)</label>
                <textarea name="recepcao_outro" value={formData.recepcao_outro} onChange={handleInputChange} placeholder="Deixe aqui suas observações..." />
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={anonimo ? () => { setAnonimo(false); setStep(0); window.scrollTo(0, 0); } : prevStep}>Voltar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={nextStep}>Continuar</button>
              </div>
            </div>
          )}

          {/* Step 3: Equipe de Enfermagem */}
          {step === 3 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">👩‍⚕️</span>
                <h2>Equipe de Enfermagem</h2>
              </div>
              <table className="rating-table">
                <thead>
                  <tr>
                    <th>Critério</th>
                    <th>Ótimo</th>
                    <th>Bom</th>
                    <th>Regular</th>
                    <th>Ruim</th>
                  </tr>
                </thead>
                <tbody>
                  <RatingRow criterio="Cordialidade e simpatia" name="enfermagem_cordialidade" value={formData.enfermagem_cordialidade} onChange={handleChange} />
                  <RatingRow criterio="Rapidez no atendimento" name="enfermagem_rapidez" value={formData.enfermagem_rapidez} onChange={handleChange} />
                  <RatingRow criterio="Cuidado com medicamentos" name="enfermagem_cuidado_medicamentos" value={formData.enfermagem_cuidado_medicamentos} onChange={handleChange} />
                  <RatingRow criterio="Orientações sobre procedimentos" name="enfermagem_orientacoes" value={formData.enfermagem_orientacoes} onChange={handleChange} />
                  <RatingRow criterio="Atenção às necessidades" name="enfermagem_atencao" value={formData.enfermagem_atencao} onChange={handleChange} />
                </tbody>
              </table>
              <div className="form-group" style={{ marginTop: '25px' }}>
                <label>Observações (opcional)</label>
                <textarea name="enfermagem_outro" value={formData.enfermagem_outro} onChange={handleInputChange} placeholder="Deixe aqui suas observações..." />
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={prevStep}>Voltar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={nextStep}>Continuar</button>
              </div>
            </div>
          )}

          {/* Step 4: Estrutura e Acomodações */}
          {step === 4 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">🏨</span>
                <h2>Estrutura e Acomodações</h2>
              </div>
              <table className="rating-table">
                <thead>
                  <tr>
                    <th>Critério</th>
                    <th>Ótimo</th>
                    <th>Bom</th>
                    <th>Regular</th>
                    <th>Ruim</th>
                  </tr>
                </thead>
                <tbody>
                  <RatingRow criterio="Limpeza do quarto" name="estrutura_limpeza_quarto" value={formData.estrutura_limpeza_quarto} onChange={handleChange} />
                  <RatingRow criterio="Limpeza do banheiro" name="estrutura_limpeza_banheiro" value={formData.estrutura_limpeza_banheiro} onChange={handleChange} />
                  <RatingRow criterio="Conforto da cama" name="estrutura_conforto_cama" value={formData.estrutura_conforto_cama} onChange={handleChange} />
                  <RatingRow criterio="Temperatura ambiente" name="estrutura_temperatura" value={formData.estrutura_temperatura} onChange={handleChange} />
                  <RatingRow criterio="Nível de ruído" name="estrutura_ruido" value={formData.estrutura_ruido} onChange={handleChange} />
                  <RatingRow criterio="Equipamentos (TV, etc)" name="estrutura_equipamentos" value={formData.estrutura_equipamentos} onChange={handleChange} />
                </tbody>
              </table>
              <div className="form-group" style={{ marginTop: '25px' }}>
                <label>Observações (opcional)</label>
                <textarea name="estrutura_outro" value={formData.estrutura_outro} onChange={handleInputChange} placeholder="Deixe aqui suas observações..." />
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={prevStep}>Voltar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={nextStep}>Continuar</button>
              </div>
            </div>
          )}

          {/* Step 5: Alimentação */}
          {step === 5 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">🍽️</span>
                <h2>Alimentação / Nutrição</h2>
              </div>
              <table className="rating-table">
                <thead>
                  <tr>
                    <th>Critério</th>
                    <th>Ótimo</th>
                    <th>Bom</th>
                    <th>Regular</th>
                    <th>Ruim</th>
                  </tr>
                </thead>
                <tbody>
                  <RatingRow criterio="Qualidade das refeições" name="alimentacao_qualidade" value={formData.alimentacao_qualidade} onChange={handleChange} />
                  <RatingRow criterio="Temperatura dos alimentos" name="alimentacao_temperatura" value={formData.alimentacao_temperatura} onChange={handleChange} />
                  <RatingRow criterio="Variedade do cardápio" name="alimentacao_variedade" value={formData.alimentacao_variedade} onChange={handleChange} />
                  <RatingRow criterio="Apresentação dos pratos" name="alimentacao_apresentacao" value={formData.alimentacao_apresentacao} onChange={handleChange} />
                  <RatingRow criterio="Pontualidade na entrega" name="alimentacao_pontualidade" value={formData.alimentacao_pontualidade} onChange={handleChange} />
                  <RatingRow criterio="Atendimento da copeira" name="alimentacao_atendimento_copeira" value={formData.alimentacao_atendimento_copeira} onChange={handleChange} />
                </tbody>
              </table>
              <div className="form-group" style={{ marginTop: '25px' }}>
                <label>Observações (opcional)</label>
                <textarea name="alimentacao_outro" value={formData.alimentacao_outro} onChange={handleInputChange} placeholder="Deixe aqui suas observações..." />
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={prevStep}>Voltar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={nextStep}>Continuar</button>
              </div>
            </div>
          )}

          {/* Step 6: Avaliação Geral */}
          {step === 6 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">⭐</span>
                <h2>Avaliação Geral</h2>
              </div>

              <div className="form-group">
                <label style={{ fontSize: '1.1rem', marginBottom: '20px', display: 'block', fontWeight: '600' }}>
                  De 0 a 10, qual nota você daria para sua experiência?
                </label>
                <div className="nota-scale">
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(nota => (
                    <label key={nota} className="nota-btn">
                      <input type="radio" name="nota_geral" value={nota} checked={formData.nota_geral === nota} onChange={() => handleChange('nota_geral', nota)} />
                      <span>{nota}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group" style={{ marginTop: '40px' }}>
                <label style={{ fontSize: '1.1rem', marginBottom: '20px', display: 'block', fontWeight: '600' }}>
                  Você recomendaria nosso hospital?
                </label>
                <div className="recomendacao-options">
                  {opcoesRecomendacao.map(opcao => (
                    <label key={opcao.value} className="recomendacao-btn">
                      <input type="radio" name="recomendaria" value={opcao.value} checked={formData.recomendaria === opcao.value} onChange={() => handleChange('recomendaria', opcao.value)} />
                      <span>{opcao.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group" style={{ marginTop: '25px' }}>
                <label>Observações gerais (opcional)</label>
                <textarea name="avaliacao_geral_outro" value={formData.avaliacao_geral_outro} onChange={handleInputChange} placeholder="Deixe aqui suas observações..." />
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={prevStep}>Voltar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={nextStep}>Continuar</button>
              </div>
            </div>
          )}

          {/* Step 7: Comentários e Sugestões */}
          {step === 7 && (
            <div className="card">
              <div className="card-header">
                <span className="icon">💬</span>
                <h2>Comentários e Sugestões</h2>
              </div>

              <div className="form-group">
                <label>Algum profissional se destacou? (nome e setor)</label>
                <textarea name="profissional_destaque" value={formData.profissional_destaque} onChange={handleInputChange} placeholder="Ex: Enfermeira Maria do setor de internação..." />
              </div>

              <div className="form-group">
                <label>O que podemos melhorar?</label>
                <textarea name="sugestao_melhoria" value={formData.sugestao_melhoria} onChange={handleInputChange} placeholder="Suas sugestões são muito importantes..." />
              </div>

              <div className="form-group">
                <label>Elogio ou reclamação específica?</label>
                <textarea name="elogio_reclamacao" value={formData.elogio_reclamacao} onChange={handleInputChange} placeholder="Compartilhe sua experiência..." />
              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <button className="btn btn-secondary" onClick={prevStep}>Voltar</button>
                <button className="btn btn-success btn-lg" style={{ flex: 1 }} onClick={handleSubmit} disabled={loading}>
                  {loading ? 'Enviando...' : 'Enviar Avaliação'}
                </button>
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="footer-info">
            <img src="/logo.jpg" alt="Hospital Unique" />
            <p>Suas respostas são confidenciais</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default AvaliacaoForm;
